function absolutize(link) {
  if (link.includes('//')) return link;

  return `//${link}`;
}

export default absolutize;
